
import { useState, useEffect } from 'react';

import { hasAccess, ROLE_CARRIER, ROLE_OPERATOR } from '../../utils/access';

export const useValidations = (values, submitted) => {
  const [validations, updateValidations] = useState({});
  const checkValue = field => values[field] && (Array.isArray(values[field]) ? !!values[field].length : !!values[field].value);

  useEffect(() => {
    let newValidations = {
      all: true,
      alaLevels: true,
      autoApprovalAlaLevel: true,
      origin: true,
      destination: true,
      operator: true,
      carrier: true,
      startDate: true,
      stopDate: true,
      exStartDate: true,
      exStopDate: true,
    };
    const tempValues = {
      alaLevels: values.alaLevels && values.alaLevels.length,
    };

    tempValues.startDate = !!values.startDate;
    tempValues.stopDate = !!values.stopDate;
    tempValues.operator = checkValue('operator');
    tempValues.carrier = checkValue('carrier');
    tempValues.origin = checkValue('origin');
    tempValues.destination = checkValue('destination');

    if (hasAccess([ROLE_CARRIER])) {
      tempValues.carrier = true;
    } else if (hasAccess([ROLE_OPERATOR])) {
      tempValues.operator = true;
    }

    if (values.autoApprovalOn) {
      tempValues.autoApprovalAlaLevel = checkValue('autoApprovalAlaLevel');
    }

    if (values.exPeriod) {
      tempValues.exStartDate = !!values.exStartDate;
      tempValues.exStopDate = !!values.exStopDate;
    }


    newValidations.all = !Object.keys(tempValues).filter(item => !tempValues[item]).length;

    if (submitted) {
      newValidations = {
        ...newValidations,
        ...tempValues,
      };
    }

    updateValidations(newValidations);
  }, [values, submitted]);

  return [validations];
};
